import { SEOProps } from "../../components/SEO"
import { NextSeoProps } from "next-seo"

const twitterSite = ""

const fallbackTwitterCardType: NextSeoProps["twitter"]["cardType"] = ""

const getTwitterSEOProps = (props: SEOProps) => {
	const cardType = props?.twitter?.cardType ?? fallbackTwitterCardType

	const twitterSEOProps: NextSeoProps = {
		twitter: {
			site: twitterSite,
			cardType,
		},
	}

	return twitterSEOProps
}

export default getTwitterSEOProps
